/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4a70827e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4a70827e&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户四川护理-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__